function resetForm(selector){
    if (document.querySelector(selector) !== null){
        const getForm = document.querySelector(selector);
        getForm.reset();
    }
}
module.exports = resetForm;